module.exports = __webpack_public_path__ + "img/vx-flow-banner-2.2e77eeed.png";